<div class="flex flex-col gap-y-2">
    @if (expanded()) {
        <interacta-input-search
            #searchInput
            class="mr-4 ml-12"
            iconPosition="right"
            [control]="communityFilter"
            [label]="'UI.BUTTON.SEARCH' | translate"
        />
    } @else {
        <button
            class="mr-4 ml-12 h-40 w-max text-text-mid-contrast"
            interacta-icon-button
            type="button"
            [icon]="'search-left'"
            [label]="'UI.BUTTON.SEARCH' | translate"
            [size]="'regular'"
            [style]="'text'"
            [tooltipPosition]="'right'"
            (click)="openSidebarAndFocusInput()"
        ></button>
    }

    <div class="flex grow flex-col overflow-x-hidden overflow-y-auto pb-2">
        @if (filteredData()) {
            <interacta-sidebar-workspace-list
                [expanded]="expanded()"
                [pinEnabled]="true"
                [selectedCommunity]="selectedCommunity()"
                [showDashboardLink]="
                    showDashboardLink() && !communityFilterValue()
                "
                [uiStates]="uiStates()"
                [workspaceList]="filteredData()"
                (collapsedWs)="collapsedWs.emit($event)"
            />
        }
    </div>
</div>
